import { Zalacznik } from '../../wspolne/zalacznik';
import { PoleSpisuSrodkaDoZapisu } from './poleSpisuSrodkaDoZapisu';

export class DodajSrodekModel {
  pola: Array<PoleSpisuSrodkaDoZapisu> = new Array();
  zdjecia: Array<Zalacznik> = new Array();
  idProjektu: string;
  idPomieszczenia: string;
  idSrodkaZKtorymSparowac: string;
}
